package com.trevorwiebe.timesheet.payPeriod.presentation

import com.trevorwiebe.timesheet.core.presentation.DisposableViewModel
import androidx.lifecycle.viewModelScope
import com.trevorwiebe.timesheet.core.data.FirestoreListenerRegistry
import com.trevorwiebe.timesheet.core.domain.CoreRepository
import com.trevorwiebe.timesheet.core.domain.Util.getTimeSheetStatus
import com.trevorwiebe.timesheet.core.domain.model.TimeSheet
import com.trevorwiebe.timesheet.core.domain.usecases.GetCurrentPayPeriodStartAndEnd
import com.trevorwiebe.timesheet.payPeriod.domain.PayPeriodRepository
import com.trevorwiebe.timesheet.payPeriod.presentation.uiUtils.UiTimeSheet
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import kotlin.time.Clock
import kotlin.time.ExperimentalTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

class PayPeriodViewModel(
    private val payPeriodRepository: PayPeriodRepository,
    private val coreRepository: CoreRepository,
    private val userId: String? = null,
) : DisposableViewModel() {

    private val _staticPayPeriodState = MutableStateFlow(StaticPayPeriodState())
    val staticPayPeriodState = _staticPayPeriodState.asStateFlow()

    init { getTimeSheets() }

    @Suppress("UNCHECKED_CAST")
    private fun getTimeSheets() {
        val job = viewModelScope.launch {
            payPeriodRepository.getTimeSheets(userId).collect { result ->
                if (result.error.isNullOrEmpty()) {
                    val timeSheets = result.data as List<TimeSheet>
                    initiateTimeSheetStatusProcessing(timeSheets)
                }
            }
        }
        FirestoreListenerRegistry.registerJob(job)
    }

    @OptIn(ExperimentalTime::class)
    private suspend fun initiateTimeSheetStatusProcessing(timeSheets: List<TimeSheet>){
        val result = coreRepository.getOrganization()
        if (result.error.isNullOrEmpty()) {

            val mutableTimeSheet = mutableListOf<UiTimeSheet>()

            val currentDate = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).date

            timeSheets.forEach {

                val currentPeriod =
                        currentDate >= it.payPeriodStart.date &&
                        currentDate <= it.payPeriodEnd.date

                val timeSheetStatus = getTimeSheetStatus(it, currentPeriod)
                mutableTimeSheet.add(UiTimeSheet(it, timeSheetStatus))
            }
            _staticPayPeriodState.value = _staticPayPeriodState.value.copy(
                timeSheets = mutableTimeSheet.toList()
                    .sortedByDescending { it.timeSheet.payPeriodStart }
            )
        }
    }
}